import React, { Fragment, useEffect, useState } from "react";
import AlternativeListItem from "../Components/AlternativeListItem";
import { addMultiple as addMultipleToCart } from "../Actions/Cart.action";
import { translate } from "../Services/translation";
import { useDispatch } from "react-redux";

export default function AlternativeVariantListContainer(props) {
  const { variants } = props;
  const [products, setProducts] = useState(variants);
  const [selectedLast, setSelectedLast] = useState("");
  const [lasts, setLasts] = useState([]);
  const [currentCart, setCurrentCart] = useState([]);
  const [cartQuantity, setCartQuantity] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [containerClass, setContainerClass] = useState(
    "alternative-list__container--show"
  );
  const dispatch = useDispatch();

  const ChangeLastCollection = (lastName) => {
    let lasts = [];
    if (!lastName) {
      products.forEach(function (item) {
        if (!lasts.includes(item.Last)) {
          if (item.Last) {
            lasts.push(item.Last);
          }
        }
      });
      products.forEach(function (item) {
        if (!lasts.includes(translate("alternativevariant.notspecified"))) {
          if (!item.Last) {
            lasts.push(translate("alternativevariant.notspecified"));
          }
        }
      });
      setLasts(lasts);
      if (lasts.length > 0) {
        lastName = lasts[0];
        if (lastName == translate("alternativevariant.notspecified")) {
          lastName = null;
        }
        setProducts(
          variants
            .filter((x) => x.Last == lastName)
            .sort(function (a, b) {
              return a.Size - b.Size;
            })
        );
        setSelectedLast(
          lastName == null
            ? translate("alternativevariant.notspecified")
            : lastName
        );
      }
    } else {
      setContainerClass("");
      handleSelected(lastName);
    }
  };

  const handleSelected = (lastName) => {
    setSelectedLast(lastName);
    setTimeout(() => {
      setContainerClass("alternative-list__container--show");
      if (lastName == translate("alternativevariant.notspecified")) {
        lastName = null;
      }
      setProducts(
        variants
          .filter((x) => x.Last == lastName)
          .sort(function (a, b) {
            return a.Size - b.Size;
          })
      );
    }, 200);
  };

  const addToCartList = (articleNumber, quantity, price) => {
    var itemIndex = currentCart.findIndex(
      (item) => item.articleNumber == articleNumber
    );
    if (itemIndex != -1) {
      if (quantity > 0) {
        let tempPrice = price.Price.Price;
        currentCart[itemIndex].quantity = quantity;
        if (price.TierPrices.length > 0) {
          let tempPriceList = price.TierPrices.filter(
            (x) => x.MinimumQuantity <= quantity
          );
          if (tempPriceList.length > 0) {
            let priceObject = tempPriceList[tempPriceList.length - 1];
            tempPrice = priceObject.Price;
          }
        }
        currentCart[itemIndex].price = parseFloat(tempPrice) * quantity;
      } else {
        currentCart.splice(itemIndex, 1);
      }
    } else {
      let tempPrice = price.Price.Price;
      if (price.TierPrices.length > 0) {
        let tempPriceList = price.TierPrices.filter(
          (x) => x.MinimumQuantity <= quantity
        );
        if (tempPriceList.length > 0) {
          let priceObject = tempPriceList[tempPriceList.length - 1];
          tempPrice = priceObject.Price;
        }
      }
      var cartItemObject = {
        quantity: quantity,
        articleNumber: articleNumber,
        price: parseFloat(tempPrice) * quantity,
      };
      currentCart.push(cartItemObject);
    }
    let totalQuantity = 0;
    let totalPrice = 0;

    currentCart.forEach(function (item) {
      totalQuantity += parseInt(item.quantity);
      totalPrice += parseFloat(item.price);
    });
    setCurrentCart(currentCart);
    setCartQuantity(totalQuantity);
    setTotalPrice(totalPrice);
  };

  const getFormattedPrice = (price) => {
    let currency = variants[0].Currency.Id;
    let symbol = variants[0].Currency.Symbol;

    if (currency == "SEK" || currency == "NOK" || currency == "DKK") {
      return price.toFixed(2).toString().replace(".", ",") + " " + symbol;
    } else if (currency == "EUR") {
      return symbol + price;
    } else if (currency == "GBP") {
      return symbol + price;
    }
  };

  const addToCart = () => {
    if (currentCart.length > 0) {
      dispatch(addMultipleToCart(currentCart));
    }
  };

  useEffect(() => {
    ChangeLastCollection();
  }, []);

  return (
    <>
      <div className={lasts.length <= 1 ? "hide" : ""}>
        <h5 className="alternative-list__headline alternative-headline">
          {translate("alternativevariant.picklast")}
        </h5>
        <div className="alternative-list__last-container">
          {lasts &&
            lasts.map((last) => (
              <div
                className="alternative-list__last-wrapper large-4 small-12 columns"
                key={last}
              >
                <div
                  className={
                    selectedLast == last
                      ? "alternative-list__last alternative-list__last--selected"
                      : "alternative-list__last"
                  }
                  onClick={() => ChangeLastCollection(last)}
                >
                  <h6>{last}</h6>
                </div>
              </div>
            ))}
        </div>
      </div>
      <div className="alternative-list__choice">
        <h5>{translate("alternativevariant.choice")}:</h5>
        <span>
          {products[0].Name} | {products[0].Color}{" "}
          {lasts.length > 1 && "|" + selectedLast}
        </span>
      </div>
      <div
        className={
          containerClass
            ? "alternative-list__container alternative-list__container--show"
            : "alternative-list__container"
        }
      >
        <ul>
          <li className="alternative-list__container--header show-for-large">
            <div className="large-1 paragraph-m columns">
              {translate("alternativevariant.size")}
            </div>
            <div className="large-3 paragraph-m columns">
              {translate("alternativevariant.articleno")}
            </div>
            <div className="large-2 paragraph-m columns">
              {translate("alternativevariant.ean")}
            </div>
            <div className="large-3 paragraph-m columns">
              {products[0].IsLoggedIn &&
                translate("alternativevariant.avaiability")}
            </div>
            <div className="large-2 paragraph-m columns text--right">
              {products[0].IsLoggedIn &&
                translate("checkout.cart.header.price")}
            </div>
            <div className="large-1 paragraph-m columns text--center">
              {products[0].IsLoggedIn &&
                translate("checkout.cart.header.quantity")}
            </div>
          </li>
          {products &&
            products.map((variant) => (
              <AlternativeListItem
                key={variant.Id}
                {...{
                  ...variant,
                  addToCartList,
                  getFormattedPrice,
                  quantity: currentCart.filter(
                    (x) => x.articleNumber == variant.Id
                  ).length
                    ? currentCart.filter(
                        (x) => x.articleNumber == variant.Id
                      )[0].quantity
                    : 0,
                }}
              />
            ))}
        </ul>
      </div>
      {products[0].IsLoggedIn && (
        <div className="alternative-list__purchase-container">
          <div className="alternative-list__purchase-info-container">
            <span className="paragraph-l">
              {translate("alternativevariant.totalarticles")}: {cartQuantity}{" "}
              {translate("alternativevariant.pcs")}
            </span>
            <h5>
              {translate("alternativevariant.totalprice")}:{" "}
              {getFormattedPrice(totalPrice)}
              <span className="paragraph-xs no-vat">
                {products[0].IsLoggedIn &&
                  translate("alternativevariant.excluding")}
              </span>
            </h5>
          </div>
          <div
            className="alternative-list__purchase-button button-primary"
            onClick={() => addToCart()}
          >
            {translate("alternativevariant.purchase")}
          </div>
        </div>
      )}
    </>
  );
}
